import { text } from '#contract'
import { useClient } from '../../app/client-context.ts'
import { useView } from '../../app/use-view.ts'
import { SettingRow } from '../../components/setting-row.tsx'
import { Slider } from '../../components/slider.tsx'
import { useT } from '../../i18n/index.ts'
import { formatPercent } from './format.ts'
import { ResetSection } from './reset-section.tsx'
import styles from './settings-screen.module.css'

const CATEGORIES = ['master', 'music', 'sfx', 'voice'] as const

/** Volume for each bus, from 0 to 100. Releasing a slider plays a click. */
export function AudioTab() {
  const t = useT()
  const client = useClient()
  const audio = useView((view) => view.settings.audio)

  return (
    <div class={styles.stack}>
      {CATEGORIES.map((category) => (
        <SettingRow key={category} label={t(text(`settings.audio.${category}`))}>
          <Slider
            min={0}
            max={1}
            step={0.01}
            value={audio[category]}
            format={formatPercent}
            onChange={(value) => {
              client?.updateSettings({ audio: { [category]: value } })
            }}
            onRelease={() => {
              client?.playUiSound('click')
            }}
          />
        </SettingRow>
      ))}
      <ResetSection section="audio" />
    </div>
  )
}
